import { useClientPrincipal } from "../context/ClientPrincipalContext";
import { useNotification } from "../context/NotificationContext";
import { ShortenedUrl } from "../types/urlShortener.types";

const useURLSearch = (
  setShortenedUrls: React.Dispatch<
    React.SetStateAction<Record<string, ShortenedUrl>>
  >,
  resetPagination: () => void
) => {
  const { setNotification } = useNotification();
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const { clientPrincipal } = useClientPrincipal();

  const userId = clientPrincipal?.userId;

  const handleSearch = async (query: string) => {
    const trimmedQuery = query.trim();

    if (!trimmedQuery) {
      setNotification({
        type: "error",
        message: "Please enter a name or URL to search.",
      });
      return;
    }

    try {
      const response = await fetch(
        `${backendUrl}/search?query=${encodeURIComponent(trimmedQuery)}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "client-principal-user-id":userId || "",
          },
          credentials: "include",
        }
      );

      if (!response.ok) {
        throw new Error("No results found.");
      }

      const data = await response.json();

      const results = data.reduce(
        (acc: Record<string, ShortenedUrl>, item: any) => {
          acc[item.short_code] = {
            url: item.original_url,
            name: item.name,
            prefix: item.prefix,
            isFavourite: item.isFavourite,
            expirationDate: item.expiration_date,
            fileFormat: "png",
            customColor: item.custom_color, 
            withLogo: item.with_logo ?? true,
          };
          return acc;
        },
        {}
      );

      setShortenedUrls((prev) => {
        const remaining = Object.fromEntries(
          Object.entries(prev).filter(([key]) => !results[key])
        );
        return { ...results, ...remaining };
      });

      resetPagination();
    } catch (error: any) {
      setNotification({
        type: "error",
        message: error.message || "Sorry! Something went wrong.",
      });
    }
  };

  return { handleSearch };
};

export default useURLSearch;
